import {ReactNode} from 'react';
import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "../hooks/useAuth.ts";


export const RequireAuth = ({children}: { children: ReactNode }) => {
    const {user} = useAuth();
    const location = useLocation();

    if (!user) {
        // Preserve productId and returnTo parameters when redirecting to signup
        const searchParams = new URLSearchParams(location.search);
        const productId = searchParams.get('productId');
        const returnTo = searchParams.get('returnTo');

        if (productId || returnTo) {
            const signupParams = new URLSearchParams();
            if (productId) signupParams.set('productId', productId);
            if (returnTo) signupParams.set('returnTo', returnTo);
            return <Navigate to={`/sign-up?${signupParams.toString()}`}/>;
        }

        return <Navigate to="/"/>;
    }
    return children;
};
